<template>
  <div class="homepage-ltr homepage-force-ltr" dir="ltr" data-homepage="true">
    <Navbar />
    <Banner />
    <KeyFeatures />
    <TailorYourDashboard />
    <OurTeam />
    <FAQ />
    <ContactUs />
    <CTA />
    <LightDarkModeBtn />
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Navbar from "@/components/FrontPages/Common/Navbar.vue";
import Banner from "@/components/FrontPages/Home/Banner.vue";
import KeyFeatures from "@/components/FrontPages/Common/KeyFeatures.vue";
import TailorYourDashboard from "@/components/FrontPages/Home/TailorYourDashboard.vue";
import OurTeam from "@/components/FrontPages/Common/OurTeam.vue";
import FAQ from "@/components/FrontPages/Common/FAQ.vue";
import ContactUs from "@/components/FrontPages/Common/ContactUs.vue";
import CTA from "@/components/FrontPages/Common/CTA.vue";
import LightDarkModeBtn from "@/components/FrontPages/Common/LightDarkModeBtn.vue";

export default defineComponent({
  name: "HomePage",
  components: {
    Navbar,
    Banner,
    KeyFeatures,
    TailorYourDashboard,
    OurTeam,
    FAQ,
    ContactUs,
    CTA,
    LightDarkModeBtn,
  },
  setup() {
    const router = useRouter();
    const { locale } = useI18n();

    // פונקציה לכפיית LTR על דף הבית
    const forceHomepageLTR = () => {
      const homepageElement = document.querySelector('[data-homepage="true"]');
      if (homepageElement) {
        homepageElement.setAttribute('dir', 'ltr');
        // ווידוא שגם הבאדי לא ישפיע על דף הבית
        const currentBodyDir = document.body.getAttribute('dir');
        if (currentBodyDir === 'rtl') {
          // שמירת הכיוון המקורי של הבאדי
          homepageElement.setAttribute('data-original-body-dir', currentBodyDir);
        }
      }
    };

    onMounted(() => {
      document.body.classList.add("padding-0");
      
      // כפיית LTR בטעינה ראשונית
      forceHomepageLTR();
      
      // בדיקה אם יש טוקן לאיפוס סיסמה בכתובת URL
      const hash = window.location.hash;
      console.log('Checking URL hash for password reset token:', hash);
      if (hash && hash.includes('access_token=') && hash.includes('type=recovery')) {
        console.log('Found password reset token, redirecting to reset password page');
        // הפנייה לדף איפוס הסיסמה עם שימור הטוקן
        router.push('/authentication/reset-password' + hash);
      }
    });

    // מעקב אחר שינויי שפה ווידוא שדף הבית נשאר LTR
    watch(() => locale.value, () => {
      // המתנה קצרה לתת לשפה להתעדכן ואז כפיית LTR
      setTimeout(() => {
        forceHomepageLTR();
      }, 100);
    });

    onBeforeUnmount(() => {
      document.body.classList.remove("padding-0");
    });

    return {};
  },
});
</script>

<style scoped>
.homepage-ltr {
  direction: ltr !important;
  text-align: left !important;
}

.homepage-ltr * {
  direction: ltr !important;
}

/* הגנה נוספת ספציפית לדף הבית */
.homepage-force-ltr {
  direction: ltr !important;
  text-align: left !important;
}

.homepage-force-ltr *,
.homepage-force-ltr *::before,
.homepage-force-ltr *::after {
  direction: ltr !important;
  text-align: inherit !important;
}

/* ביטול כל RTL utilities בדף הבית */
.homepage-force-ltr .rtl\:right-0,
.homepage-force-ltr .rtl\:left-0,
.homepage-force-ltr .rtl\:ml-0,
.homepage-force-ltr .rtl\:mr-0,
.homepage-force-ltr .rtl\:pl-0,
.homepage-force-ltr .rtl\:pr-0 {
  /* ביטול RTL positioning */
  position: static !important;
  margin: 0 !important;
  padding: 0 !important;
}

/* ווידוא שכל לינקים ואלמנטים נשארים LTR */
.homepage-force-ltr a,
.homepage-force-ltr button,
.homepage-force-ltr input,
.homepage-force-ltr textarea {
  direction: ltr !important;
  text-align: left !important;
}
</style>
